/* A section's heading inside a detail pane: the plan library's inspector (`Tydzień wzorcowy`,
 * `Rozkład partii mięśniowych`, `Przypisani klienci`) and the pattern week wherever it is drawn,
 * which is also „Nowy program"'s template preview.
 *
 * 16 / 700 in `--text`, sentence case. The owner's polish of 4 November 2026 replaced the canon's
 * eyebrow (8px / 700 / tracked capitals in `--text-3`) on all three: a section title a trainer has
 * to squint at is a label nobody reads, and the three are the pane's landmarks. The mock drew 15,
 * which is off the type scale, so it is the scale's `--type-title-3`.
 *
 * The element is an `h3`, so the user-agent margin comes off here; WHERE the heading sits (a margin
 * under it) is the host's, which knows what follows it. The line-height is the step's own fixed
 * `--type-title-3-lh`, because every host section has a reserved height and the heading is part of
 * it: a number, not a font metric. */
.heading {
  margin: var(--space-0);
  font-size: var(--type-title-3);
  font-weight: var(--fw-bold);
  line-height: var(--type-title-3-lh);
  letter-spacing: var(--ls-heading);
  color: var(--text);
}
